import { memo } from 'react';
import { formatDate, formatDateTime, formatRelativeTime } from '@alamo/utils';

import { Tooltip } from '../../Tooltip/Tooltip';

interface DateCellProps {
  value: string | null | undefined;
  format?: 'date' | 'datetime' | 'relative';
  className?: string;
}

export const DateCell = memo(function DateCell({
  value,
  format = 'date',
  className,
}: DateCellProps) {
  if (!value) {
    return <span className="text-slate-400">-</span>;
  }

  if (format === 'relative') {
    const relativeText = formatRelativeTime(value);
    const fullDate = formatDateTime(value);
    return (
      <Tooltip content={fullDate}>
        <span className={className}>{relativeText}</span>
      </Tooltip>
    );
  }

  if (format === 'datetime') {
    return <span className={className}>{formatDateTime(value)}</span>;
  }

  return <span className={className}>{formatDate(value)}</span>;
});
